import DataImport from "../../../../pages/app/admin/library/DataImport";
import ElevatedPaper, { DEFAULT_STYLE } from "../../../ElevatedPaper";

const ProviderDataImport = () => {
  return (
    <ElevatedPaper sx={{ ...DEFAULT_STYLE, minHeight: "calc(100vh - 4.5rem)" }}>
      <DataImport />
    </ElevatedPaper>
  );
};

export default ProviderDataImport;
